import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useFormErrorStore = defineStore('formError', () => {
    // state
    const formErrors = ref({});

    // actions
    const addErrors = (errors) => {
        formErrors.value = { ...errors };
    };

    // helper
    const clearErrors = () => {
        formErrors.value = {};
    };

    return {
        // state
        formErrors,
        // actions
        addErrors,
        // helpers
        clearErrors,
    };
});
